namespace Roodik.Game
{
	export enum NeighborKey
	{
		UP = 1,
		DOWN = 2,
		LEFT = 3,
		RIGHT = 4
	}
}


// WEBPACK FOOTER //
// /source/src/typescript/Game/Model/Board/NeighborKey.ts